import styled from "@emotion/styled";
import { Icon } from "@iconify/react";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { expenseTypes } from "../lib/constants";
import { useEmployee } from "../services";
import Input from "./Input";
import Select from "./Select";

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const expenseTypeOptions = expenseTypes.map((item) => ({ label: item, value: item }));

function AddVoucherFormModal({ open, onClose, onSubmit = () => {} }: { open: any; onClose: any; onSubmit?: () => void }) {
  const initialFormData = {
    expense_type: "",
    amount_requested: "",
    date_of_event: "",
    note: "",
    attachment: null,
  };
  const [formData, setFormData] = useState(initialFormData);
  const { requestVoucher } = useEmployee();

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { success, error } = await requestVoucher(formData);
    if (error) return toast.error(error);
    else {
      toast.success(success);
      handleClose();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, attachment: file });
  };

  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      aria-labelledby="add-voucher-modal"
      aria-describedby="add-voucher-modal"
    >
      <div className="modal_container full column">
        <h3 className="section_title">Request Voucher Expense</h3>
        <form id="add_voucher_form" className="column small" onSubmit={handleSubmit}>
          <div className="input_wrapper">
            <label htmlFor="expense_type" className="label">
              Expense Type*
            </label>
            <Select
              name="expense_type"
              id="expense_type"
              placeholder="Select expense type"
              options={expenseTypeOptions}
              required
              value={formData.expense_type}
              onChange={(selectedOption) => setFormData({ ...formData, expense_type: selectedOption })}
            />
          </div>
          <div className="row">
            <div className="input_wrapper full">
              <label htmlFor="amount" className="label">
                Amount*
              </label>
              <Input
                type="number"
                name="amount"
                id="amount"
                placeholder="Enter amount"
                value={formData.amount_requested}
                onChange={(e) => setFormData({ ...formData, amount_requested: e.target.value })}
                required
                min={1}
                prefix="₹"
              />
            </div>
            <div className="input_wrapper full">
              <label htmlFor="note" className="label">
                Date of event*
              </label>
              <input
                type="date"
                name="date_of_event"
                id="date_of_event"
                value={formData.date_of_event}
                onChange={(e) => setFormData({ ...formData, date_of_event: e.target.value })}
                required
                className="input"
              />
            </div>
          </div>
          <div className="input_wrapper">
            <label htmlFor="note" className="label">
              Note
            </label>
            <textarea
              name="note"
              id="note"
              placeholder="Enter note"
              value={formData.note}
              onChange={(e) => setFormData({ ...formData, note: e.target.value })}
              className="textarea"
              rows={3}
            />
          </div>
          <div className="row start">
            <label className="label gray">
              <input
                type="file"
                name="attachment"
                id="attachment"
                accept="application/pdf"
                onChange={handleFileChange}
                hidden
              />
              <span>
                <Icon icon="ion:attach-outline" className="icon" inline />
                <span className="underline">Attach File</span>
              </span>
            </label>
          </div>

          <div className="row end">
            <button type="button" className="btn ghost_outline_btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn cta_btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </ModalWrapper>
  );
}

export default AddVoucherFormModal;
